import anime from 'animejs/lib/anime.es'

import { defineComponent, ref } from '@vue/composition-api'
import Search from '../components/Search.vue'

export default defineComponent({
  name: 'AppHeaderMobile',
  components: {
    Search,
  },
  setup() {
    const menuOpen = ref(false)
    const itemIdOpen = ref(false)
    const loginMenuOpen = ref(false)
    const prevItemIdOpen = ref(false)

    const openMenuItem = id => itemIdOpen.value = id
    const closeMenuItem = () => itemIdOpen.value = false

    const toggleMenu = () => {
      menuOpen.value = !menuOpen.value
      itemIdOpen.value = false
      loginMenuOpen.value = false
      prevItemIdOpen.value = itemIdOpen.value
    }

    const openSearch = () => {
      menuOpen.value = false
      openMenuItem('search')
    }

    // Animations
    const openMenuAnim = (el, done) => {
      anime({
        targets: el,
        opacity: ['0', '1'],
        duration: 150,
        delay: prevItemIdOpen.value === false ? 0 : 150,
        easing: 'linear',
        complete: () => {
          done()
        },
      })
    }

    const closeMenuAnim = (el, done) => {
      anime({
        targets: el,
        opacity: ['1', '0'],
        duration: 150,
        delay: 0,
        easing: 'linear',
        complete: () => {
          done()
        },
      })
    }

    return {
      menuOpen,
      itemIdOpen,
      loginMenuOpen,
      prevItemIdOpen,

      toggleMenu,
      openMenuItem,
      closeMenuItem,

      openSearch,

      // Animations
      openMenuAnim,
      closeMenuAnim,
    }
  },
})
